type Options = {
  leading?: boolean;
  // Currently, there is not a need to support the following options:
  // trailing?: boolean;
  // maxWait?: number;
};

type AnyFn = (...args: any[]) => void;

const debounce = (fn: AnyFn, delay: number = 0, options: Options = {}) => {
  let timeout: ReturnType<typeof setTimeout> | undefined;
  const leading = options.leading ?? false;
  let called = false;

  let pendingArgs: Parameters<AnyFn> | undefined;

  const debounced = (...args: Parameters<AnyFn>) => {
    if (leading && !called) {
      fn(...args);
      called = true;

      return;
    }

    pendingArgs = args;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = undefined;
      fn(...args);
      called = false;
      pendingArgs = undefined;
    }, delay);
  };

  // Cancels the pending invocation without executing it
  debounced.cancel = () => {
    clearTimeout(timeout);
    timeout = undefined;
    called = false;
    pendingArgs = undefined;
  };

  // Immediately executes the pending invocation and clears the timer
  debounced.flush = () => {
    if (!timeout) return;

    clearTimeout(timeout);
    timeout = undefined;
    fn(...(pendingArgs ?? []));
    called = false;
    pendingArgs = undefined;
  };

  return debounced;
};

export { debounce };
